// CrumblePiece shop: small touches on top of plain forms. Everything still works without this file.
(function () {
  "use strict";

  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  // Pet Ziggy: tap the framed photo for pixel hearts and a purr
  document.querySelectorAll("[data-pet]").forEach(function (frame) {
    var hearts = frame.querySelector(".hearts");
    var purr = null;
    if (frame.dataset.purr) {
      purr = new Audio(frame.dataset.purr);
      purr.preload = "none";
      purr.volume = 0.8;
    }

    frame.addEventListener("click", function (event) {
      frame.classList.add("was-petted");
      frame.classList.remove("is-petted");
      void frame.offsetWidth;
      frame.classList.add("is-petted");

      if (purr) {
        try {
          purr.currentTime = 0;
          purr.play().catch(function () {});
        } catch (e) { /* no sound, still hearts */ }
      }

      if (reduceMotion || !hearts) return;
      var box = frame.getBoundingClientRect();
      var x = event.clientX ? event.clientX - box.left : box.width / 2;
      var y = event.clientY ? event.clientY - box.top : box.height / 2;
      for (var i = 0; i < 5; i++) {
        var heart = document.createElement("span");
        heart.className = "heart";
        heart.style.left = x + (Math.random() - 0.5) * 40 + "px";
        heart.style.top = y + (Math.random() - 0.5) * 20 + "px";
        heart.style.setProperty("--dx", (Math.random() - 0.5) * 120 + "px");
        heart.style.setProperty("--r", (Math.random() - 0.5) * 40 + "deg");
        heart.style.animationDelay = i * 70 + "ms";
        heart.addEventListener("animationend", function () { this.remove(); });
        hearts.appendChild(heart);
      }
    });
  });

  // Product photos: a thumbnail swaps the big polaroid
  var mainImage = document.getElementById("product-main-image");
  document.querySelectorAll(".thumb").forEach(function (thumb) {
    thumb.addEventListener("click", function (event) {
      if (!mainImage) return;
      event.preventDefault();
      mainImage.srcset = thumb.dataset.srcset;
      mainImage.src = thumb.dataset.full;
      var img = thumb.querySelector("img");
      if (img) mainImage.alt = img.alt;
      document.querySelectorAll(".thumb.is-active").forEach(function (t) { t.classList.remove("is-active"); });
      thumb.classList.add("is-active");
    });
  });

  // Variant menu: update the price tag and the basket button
  var variantSelect = document.querySelector("[data-variant-select]");
  if (variantSelect) {
    var priceTag = document.getElementById("product-price");
    var addButton = document.querySelector("[data-add-button]");
    variantSelect.addEventListener("change", function () {
      var option = variantSelect.options[variantSelect.selectedIndex];
      var html = '<span class="price">' + option.dataset.price + "</span>";
      if (option.dataset.compare) html += '<s class="price-was">' + option.dataset.compare + "</s>";
      if (priceTag) priceTag.innerHTML = html;
      if (addButton) {
        var available = option.dataset.available === "true";
        addButton.disabled = !available;
        addButton.querySelector("span").textContent = available ? addButton.dataset.labelAdd : addButton.dataset.labelSold;
      }
      var url = new URL(window.location.href);
      url.searchParams.set("variant", option.value);
      window.history.replaceState({}, "", url.toString());
    });
  }

  // Quantity buttons (product page and basket)
  document.querySelectorAll(".qty").forEach(function (qty) {
    var input = qty.querySelector("input");
    qty.querySelectorAll("[data-qty]").forEach(function (button) {
      button.addEventListener("click", function () {
        var min = parseInt(input.min || "0", 10);
        var next = (parseInt(input.value, 10) || 0) + parseInt(button.dataset.qty, 10);
        input.value = Math.max(min, next);
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });
    });
  });

  // Basket: save a new quantity straight away (a plain submit updates the basket, it doesn't check out)
  var cartForm = document.querySelector("[data-cart-form]");
  if (cartForm) {
    var timer = null;
    cartForm.addEventListener("change", function (event) {
      if (event.target.name !== "updates[]") return;
      clearTimeout(timer);
      timer = setTimeout(function () { cartForm.submit(); }, 450);
    });
    // Enter in a quantity field should update, not check out
    cartForm.addEventListener("keydown", function (event) {
      if (event.key === "Enter" && event.target.name === "updates[]") {
        event.preventDefault();
        cartForm.submit();
      }
    });
  }

  // Sorting a collection
  document.querySelectorAll("[data-autosubmit]").forEach(function (form) {
    form.addEventListener("change", function () { form.submit(); });
  });

  // Close the phone menu when tapping outside it
  document.addEventListener("click", function (event) {
    document.querySelectorAll(".menu-drawer[open]").forEach(function (drawer) {
      if (!drawer.contains(event.target)) drawer.removeAttribute("open");
    });
  });
})();
